/* HANYRIX premium layer - apparition au scroll, header, progression. Sans dependance. */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  function onScroll(){
    var y = window.scrollY || document.documentElement.scrollTop;
    document.body.classList.toggle('hx-scrolled', y > 40);
    if (bar){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
    }
  }

  var bar = null;
  function initProgress(){
    if (reduce || inEditor) return;
    bar = document.createElement('div');
    bar.className = 'hx-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }

  function initReveal(){
    if (reduce || inEditor || !('IntersectionObserver' in window)) return;
    var selector = 'main .shopify-section h1, main .shopify-section h2, main .shopify-section .product-card, main .shopify-section product-card, main .shopify-section .collection-card, main .shopify-section .button, main .shopify-section img.product-card__image';
    var nodes = document.querySelectorAll(selector);
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('hx-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var firstScreen = window.innerHeight;
    nodes.forEach(function(el, i){
      if (el.getBoundingClientRect().top < firstScreen * 0.9) return; // le haut de page reste visible immediatement
      el.classList.add('hx-reveal');
      el.style.setProperty('--hx-delay', ((i % 4) * 90) + 'ms');
      io.observe(el);
    });
  }

  function start(){
    initProgress();
    initReveal();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
